export const module = {
  info: {
    name: 'voip-reseller-rate',
    caption: 'voip reseller rate'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
